<template>
  <transition
    name="expandable"
    @enter="startTransition"
    @after-enter="endTransition"
    @before-leave="startTransition"
    @after-leave="endTransition"
  >
    <div
      v-show="expanded"
      :style="cssVars"
      class="overflow-hidden"
    >
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    expanded: {
      type: Boolean,
      required: true,
    },
    transitionTime: {
      type: String,
      default: "0.1s",
    },
  },
  computed: {
    cssVars() {
      return {
        "--transition-time": this.transitionTime,
      };
    },
  },
  methods: {
    startTransition(el) {
      el.style.height = el.scrollHeight + "px";
    },

    endTransition(el) {
      el.style.height = "";
    },
  },
};
</script>

<style scoped>
.expandable-enter-active,
.expandable-leave-active {
  will-change: height;
  transition: height var(--transition-time) ease-in-out;
}
.expandable-enter-from,
.expandable-leave-to {
  height: 0 !important;
}
</style>